import * as go from 'gojs';
import { SnapLinkReshapingTool } from '../tools/SnapLinkReshapingTool';
import { GuidedDraggingTool } from '../tools/GuidedDraggingTool';
import { RealtimeDragSelectingTool } from '../tools/RealtimeDragSelectingTool';
import { LocalStorageCommandHandler } from '../tools/LocalStorageCommandHandler';
import { NodeLabelDraggingTool } from '../tools/NodeLabelDraggingTool';
import { DefaultLinkTemplate } from '../templates/linkTemplates/defaultLinkTemplate';
import templateMap from '../templates/templateMap';
import ContextMenu from '../contextMenu/contextMenu';
import { PanelNames } from '../templates/nodeTemplates/utils/panelNames';
import { store } from 'createStore';
import { setShowContextMenu } from 'store/contextmenu/reducer';
import { groupTemplate } from '../templates/groupTemplate';

const $ = go.GraphObject.make;

export const createGraphLinksModel = () => {
  return $(go.GraphLinksModel, {
    nodeKeyProperty: 'key',
    linkKeyProperty: 'key',
    linkFromPortIdProperty: 'fromPort',
    linkToPortIdProperty: 'toPort',
  });
};

export const createBaseDiagram = (model: go.GraphLinksModel) => {
  const diagram = $(go.Diagram, {
    grid: $(
      go.Panel,
      'Grid',
      {
        gridCellSize: new go.Size(16, 16),
        gridOrigin: new go.Point(0, 0),
        background: '#FAFAFA',
      },
      $(go.Shape, 'LineH', {
        stroke: '#E0E0E0',
        strokeWidth: 0.5,
        interval: 6,
      }),
      $(go.Shape, 'LineV', {
        stroke: '#E0E0E0',
        strokeWidth: 0.5,
        interval: 6,
      }),
    ),
    'undoManager.isEnabled': true,
    'draggingTool.isGridSnapEnabled': true,
    linkReshapingTool: $(SnapLinkReshapingTool),
    LinkReshaped: function (e) {
      e.subject.adjusting = go.Link.End;
      diagram.requestUpdate();
    },
    'animationManager.isEnabled': false,
    draggingTool: new GuidedDraggingTool(),
    'draggingTool.horizontalGuidelineColor': '#327DFF',
    'draggingTool.verticalGuidelineColor': '#327DFF',
    'draggingTool.centerGuidelineColor': '#327DFF',
    'draggingTool.guidelineWidth': 2,
    'draggingTool.isCopyEnabled': false,
    'undoManager.maxHistoryLength': 0,
    'rotatingTool.handleDistance': 30,
    'rotatingTool.handleAngle': -45,
    'rotatingTool.snapAngleMultiple': 90,
    'rotatingTool.snapAngleEpsilon': 45,
    dragSelectingTool: $(
      RealtimeDragSelectingTool,
      {
        isPartialInclusion: true,
        delay: 100,
      },
      {
        box: $(
          go.Part,
          { layerName: 'Tool', selectable: false },
          $(go.Shape, {
            name: PanelNames.UNIT_NODE_SELECTION_SHAPE,
            fill: '#E6F5FF40',
            stroke: '#327DFF',
            strokeWidth: 2,
          }),
        ),
      },
    ),
    model: model,
    initialScale: 0.75,
    maxScale: 5,
    minScale: 0.25,
  });

  const showContextMenu = () => {
    store.dispatch(setShowContextMenu(true));
  };

  const hideContextMenu = () => {
    store.dispatch(setShowContextMenu(false));
  };

  diagram.commandHandler = new LocalStorageCommandHandler();
  diagram.commandHandler.canCopySelection();

  diagram.commandHandler.zoomToFit = function () {
    diagram.alignDocument(go.Spot.Center, go.Spot.Center);
    diagram.zoomToFit();
    if (diagram.scale < 1) {
      diagram.scale = diagram.scale * 0.9;
    }
  };
  diagram.nodeTemplateMap = templateMap;
  diagram.groupTemplate = groupTemplate;
  diagram.linkTemplate = DefaultLinkTemplate;
  diagram.contextMenu = ContextMenu(diagram, showContextMenu, hideContextMenu);
  diagram.grid.visible = true;
  diagram.toolManager.draggingTool.isGridSnapEnabled = true;
  diagram.toolManager.mouseMoveTools.insertAt(0, new NodeLabelDraggingTool());
  diagram.scrollMode = go.Diagram.InfiniteScroll;
  const tool = diagram.toolManager.resizingTool;
  tool.computeResize = function (newPoint, spot, min, max, cell, _reshape) {
    return go.ResizingTool.prototype.computeResize.call(
      tool,
      newPoint,
      spot,
      min,
      max,
      cell,
      false,
    );
  };

  return diagram;
};
